export default __webpack_public_path__ + "static/speech-formulas-21e75831605105d36832b9fef06ec91a.png";